class CartProgressBar extends HTMLElement {
  constructor() {
    super();
    this.settings = window.cartSettings
    
    this.init();
  }

  init() {
    document.addEventListener('cart:updated', (e) => this.calcProgressBar(e))
  }

  buildProgressBar() {
    const message = this.settings.cartTotalPrice >= this.settings.threshold.amount ? this.settings.successMessage : this.settings.message;
    const amountLeft = this.settings.threshold.amount - this.settings.cartTotalPrice;
    const priceHtml = `
      <strong>${this.formatMoney(amountLeft, window.theme.moneyFormat)}</strong>
    `
    const percent = this.settings.cartTotalPrice >= this.settings.threshold.amount ? 100 : 100 * this.settings.cartTotalPrice / this.settings.threshold.amount;

    let html = `
      <div class="free-shipping-bar__msg">${message.replace('{xx}', priceHtml)}</div>
      <div class="free-shipping-bar__progress-wrap" role="progressbar"> 
        <div class="free-shipping-bar__progress" style="width: ${percent}%"></div>
      </div>
      `;

    this.innerHTML = html;
    if (this.settings.cartTotalPrice == 0) {
      this.classList.add('hidden')
    } else {
      this.classList.remove('hidden')
    }
  }

  calcProgressBar(e) {
    if (typeof e.detail.cartTotalPrice !== 'undefined') {
      this.settings.cartTotalPrice = e.detail.cartTotalPrice
      this.buildProgressBar();
    }
  }

  formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    var value = '';

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value).replace(',00', '');
    } else {
      return formatString.replace(placeholderRegex, value).replace('.00', '');
    }
  }
}

if (!customElements.get('component-cart-progress-bar')) {
  customElements.define('component-cart-progress-bar', CartProgressBar);
}
